import { connect } from '@atlassian/jira-react-redux';
import { getComponentsPageRequest } from '../../state/actions';

import { getCurrentPage } from '../../state/query/selectors';
import type { State } from '../../state/reducer';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors';

import ErrorView from './view';

const mapStateToProps = (state: State) => ({
	isLoading: isPageLoading(state),
	currentPage: getCurrentPage(state),
});

const mapDispatchToProps = {
	onRetry: getComponentsPageRequest,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(ErrorView);
